<template>
  <div class="container container-fixed-lg p-t-20 p-b-20 p-l-20 p-r-20">
    <div v-if="displayTabs">
      <ul class="nav nav-tabs nav-tabs-fillup hidden-sm-down" data-init-reponsive-tabs="dropdownfx">
        <li class="nav-item col-4">
          <a href="#" class="active" data-toggle="tab" data-target="#edit-user" aria-expanded="true">
            <span>{{ $t('UserForm.information_personal') }}</span>
          </a>
        </li>

        <li class="nav-item col-4">
          <a href="#" data-toggle="tab" data-target="#planning" class="" aria-expanded="false">
            <span>{{ $t('UserForm.planning') }}</span>
          </a>
        </li>

        <li class="nav-item col-4 ">
          <a href="#" data-toggle="tab" data-target="#offer_history" aria-expanded="false">
            <span>{{ $t('UserForm.offer_history') }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <div class="tab-pane slide-left active" id="edit-user" aria-expanded="true">
        <div class="row">
          <div class="card card-transparent">
            <div class="card-block">
              <user-form :isManager="isManager" :userId="userId" :entityId="entityId"/>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane slide-left" id="offer_history" aria-expanded="true">
        <offer-validated-table :candidateId='userId'/>
      </div>
      <div class="tab-pane slide-left" id="planning" aria-expanded="true">
        <candidate-planning></candidate-planning>
      </div>
    </div>
    <candidate-multi-action-popup :entityId="entityId" />
  </div>
</template>

<script>
  import UserForm from '../users/UserForm'
  import OfferValidatedTable from '@/components/offers/OfferValidatedTable'
  import { roles } from '@/settings/roles'
  import { mapGetters, mapActions } from 'vuex'
  import CandidatePlanning from './CandidatePlanning'
  import CandidateMultiActionPopup from './CandidateMultiActionPopup'

  export default {
    name: 'EditUser',
    components: {
      UserForm,
      OfferValidatedTable,
      CandidateMultiActionPopup,
      CandidatePlanning
    },
    methods: {
      ...mapActions({
        getUser: 'users/get',
      }),
    },
    computed: {
      ...mapGetters({
        user: 'users/user',
      }),
      entityId(){
        if (this.$route) {
          return parseInt(this.$route.params.entity_id);
        }
      },
      userId(){
        if (this.$route) {
          return parseInt(this.$route.params.user_id);
        }
      },
      isManager(){
        return this.user.role != roles.candidate;
      },
      displayTabs(){
        return !this.isManager && this.user.id != null
      }
    },
    mounted: function(){
      this.getUser({ userId: this.userId, entityId: this.entityId });
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/EditUser.vue